/*
 * Plan picker (snippets/plan-picker.liquid): the theme's purchase-option
 * rows on a product page. Follows the radios — one-time disables the
 * hidden selling_plan input (nothing submitted), a plan sets its id — and
 * keeps the page honest around it: #product-price shows the chosen plan's
 * price with its cycle word, the add-to-cart button says "Subscribe ·
 * $34.95 a month", and a variant change re-reads every price from the
 * JSON the snippet inlined. main.js rewrites the price block on a variant
 * change too, so the picker re-applies a tick later and wins.
 */
(() => {
  if (window.SourPlanPicker) return;

  const formatMoney = (cents, format) => {
    const n = (Number(cents) || 0) / 100;
    const f = format || '${{amount}}';
    const withDelim = (num, dec) => {
      const parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    };
    let out = f;
    if (/amount_no_decimals/.test(f)) out = f.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withDelim(n, 0));
    else if (/amount_with_comma_separator/.test(f)) out = f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDelim(n, 2).replace(/,/g, ' ').replace(/\./g, ',').replace(/ /g, '.'));
    else out = f.replace(/\{\{\s*amount\s*\}\}/g, withDelim(n, 2));
    return out.replace(/<[^>]*>/g, '');
  };

  const init = (root) => {
    if (root.__pp) return;
    root.__pp = true;
    const form = root.closest('form');
    const input = root.querySelector('[data-plan-input]');
    const radios = Array.from(root.querySelectorAll('[data-plan-radio]'));
    if (!form || !input || !radios.length) return;
    let prices = {};
    try {
      prices = JSON.parse((root.querySelector('[data-plan-prices]') || {}).textContent || '{}');
    } catch (e) {
      prices = {};
    }
    const fmt = root.dataset.moneyFormat;
    // The price block prints with the currency (money_with_currency); rows and the button without.
    const fmtCur = root.dataset.moneyCurrencyFormat || fmt;
    const cycle = root.dataset.cycleWord || '';
    const priceEl = document.getElementById('product-price');
    const helper = form.querySelector('.decorated-button--helper');
    const variantId = () => {
      const id = form.querySelector('[name="id"]');
      return id ? String(id.value) : '';
    };
    const planFor = () => {
      const on = radios.find((r) => r.checked);
      return on ? on.value : '';
    };
    const boxesFor = (plan) => {
      const r = radios.find((x) => x.value === plan);
      return r ? Number(r.dataset.boxes) || 1 : 1;
    };
    const priceOf = (plan) => {
      const v = prices[variantId()];
      if (!v) return null;
      if (!plan) return v.one;
      const p = v.plans && v.plans[plan];
      return p ? p.price : null;
    };
    // The price block (main.js writes .product__current-price on a variant change; we add the cycle beside it).
    const paintPrice = (plan) => {
      if (!priceEl) return;
      const cur = priceEl.querySelector('.product__current-price');
      if (!cur) return;
      const cents = priceOf(plan);
      let tail = priceEl.querySelector('.product__price-cycle');
      if (plan) {
        if (cents != null) cur.textContent = formatMoney(cents, fmtCur);
        if (!tail) {
          tail = document.createElement('span');
          tail.className = 'product__price-cycle';
          cur.insertAdjacentElement('afterend', tail);
        }
        const boxes = boxesFor(plan);
        tail.textContent = ' ' + (boxes > 1 ? (root.dataset.forBoxes || '').replace('[n]', String(boxes)) : cycle);
      } else {
        if (cents != null) cur.textContent = formatMoney(cents, fmtCur);
        if (tail) tail.remove();
      }
    };
    const paintButton = (plan) => {
      if (!helper || helper.closest('button').disabled) return;
      if (!plan) {
        if (window.__pf_add) helper.textContent = window.__pf_add;
        return;
      }
      const cents = priceOf(plan);
      const price = cents == null ? '' : formatMoney(cents, fmt);
      const boxes = boxesFor(plan);
      const tpl = boxes > 1 ? root.dataset.prepayCta || '' : root.dataset.subscribeCta || '';
      helper.textContent = tpl.replace('[price]', price).replace('[cycle]', cycle).replace(/\s+$/, '');
    };
    // Every row's price for the current variant.
    const paintRows = () => {
      const v = prices[variantId()];
      if (!v) return;
      root.querySelectorAll('[data-plan-price]').forEach((el) => {
        const key = el.getAttribute('data-plan-price');
        if (key === 'one') {
          el.textContent = formatMoney(v.one, fmt);
          return;
        }
        const p = v.plans && v.plans[key];
        if (!p) return;
        const b = el.querySelector('b');
        if (b) b.textContent = formatMoney(p.price, fmt);
        // The cards' per-bag line: the per-delivery price over the box's bags.
        const bags = Number(root.dataset.bags) || 0;
        const per = root.querySelector('[data-plan-per="' + key + '"]');
        if (per && bags > 0 && root.dataset.perBagWord) per.textContent = root.dataset.perBagWord.replace('[price]', formatMoney((p.per || p.price) / bags, fmt));
        const s = el.querySelector('s');
        if (p.compare > p.price) {
          if (s) s.textContent = formatMoney(p.compare, fmt);
          else {
            const strike = document.createElement('s');
            strike.textContent = formatMoney(p.compare, fmt);
            el.appendChild(strike);
          }
        } else if (s) s.remove();
      });
    };
    const apply = () => {
      const plan = planFor();
      if (plan) {
        input.value = plan;
        input.disabled = false;
        root.dataset.mode = 'subscription';
      } else {
        input.value = '';
        input.disabled = true;
        root.dataset.mode = 'onetime';
      }
      paintPrice(plan);
      paintButton(plan);
      // A one-time purchase renews nothing and has no next charge, so the
      // billing line and the terms both go with the plan they describe.
      root.querySelectorAll('[data-plan-billing], [data-plan-terms]').forEach((el) => {
        el.hidden = !plan;
      });
      root.dispatchEvent(new CustomEvent('plan:change', { bubbles: true, detail: { sellingPlan: plan } }));
    };
    radios.forEach((r) => r.addEventListener('change', apply));
    const idField = form.querySelector('[name="id"]');
    if (idField) {
      idField.addEventListener('change', () => {
        // main.js repaints the price on this same event; re-apply after it.
        setTimeout(() => {
          paintRows();
          apply();
        }, 0);
      });
    }
    paintRows();
    apply();
  };

  const boot = () => document.querySelectorAll('[data-plan-picker]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  window.SourPlanPicker = { init: init };
})();
